import ubigeoData from '../data/ubigeo.json'

type UbigeoJson = Record<string, {
  name: string
  provinces: Record<string, {
    name: string
    districts: Record<string, { name: string }>
  }>
}>

const data = ubigeoData as UbigeoJson

const normalize = (s: string): string =>
  s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()

/**
 * Given department/province/district names (from REINFO),
 * returns the most specific ubigeo code found (6 digits if district matched, 4 if province, 2 if department).
 */
export const lookupUbigeoCode = (
  departmentName: string | null,
  provinceName: string | null,
  districtName: string | null,
): string | undefined => {
  if (!departmentName) return undefined

  let deptCode = ''
  const normDept = normalize(departmentName)
  for (const [code, dept] of Object.entries(data)) {
    if (normalize(dept.name) === normDept) {
      deptCode = code
      break
    }
  }
  if (!deptCode) return undefined

  if (!provinceName) return deptCode

  let provCode = ''
  const normProv = normalize(provinceName)
  const provinces = data[deptCode]?.provinces ?? {}
  for (const [code, prov] of Object.entries(provinces)) {
    if (normalize(prov.name) === normProv) {
      provCode = code
      break
    }
  }
  if (!provCode) return deptCode

  if (!districtName) return provCode

  const normDist = normalize(districtName)
  const districts = provinces[provCode]?.districts ?? {}
  for (const [code, dist] of Object.entries(districts)) {
    if (normalize(dist.name) === normDist) {
      return code
    }
  }

  return provCode
}
